import { useEffect } from "react";
import {
  Button,
  PocketRow,
  PocketSection,
  ProjectAvatar,
} from "@/components/ui";
import { Icons } from "@/components/ui/icons";
import { useT } from "@/i18n";
import { commonMessages } from "@/i18n/messages/common";
import { settingsProjectsMessages } from "@/i18n/messages/settings-projects";
import { useSettingsNav } from "./settings-navigation";
import { refreshProjectNavigation } from "./project-page-state";
import { useProjectStore } from "@/stores/project-store";

export function ProjectsPage() {
  const t = useT(settingsProjectsMessages);
  const tc = useT(commonMessages);
  const nav = useSettingsNav();
  const allProjects = useProjectStore((state) => state.projects);
  const isLoading = useProjectStore((state) => state.isLoading);
  const loadError = useProjectStore((state) => state.error);
  const projects = allProjects.filter((item) => item.status === "active");
  // The app already holds the list: show it at once and refresh in place.
  const loading = isLoading && allProjects.length === 0;
  const error = Boolean(loadError) && allProjects.length === 0;
  useEffect(() => {
    refreshProjectNavigation();
  }, []);
  return (
    <div data-testid="settings-page-projects">
      <PocketSection testId="projects-list">
        {loading ? (
          <p role="status" className="px-2 py-3 text-appkit-body text-muted">
            {t("loadingProjects")}
          </p>
        ) : error ? (
          <div className="px-2 py-3">
            <p role="alert">{t("projectsLoadError")}</p>
            <Button
              size="sm"
              data-testid="projects-retry"
              onClick={refreshProjectNavigation}
            >
              {tc("retry")}
            </Button>
          </div>
        ) : projects.length === 0 ? (
          <p className="px-2 py-3 text-appkit-body text-muted">
            {t("noProjects")}
          </p>
        ) : (
          projects.map((project) => (
            <PocketRow
              key={project.id}
              testId={`project-row-${project.id}`}
              leading={
                <ProjectAvatar
                  name={project.name}
                  color={project.color}
                  isHome={project.is_home}
                />
              }
              title={project.name}
              secondLine={project.description || undefined}
              chevron
              onSelect={() =>
                nav.push({
                  page: "projects-project",
                  args: { projectId: project.id, title: project.name },
                })
              }
            />
          ))
        )}
        <PocketRow
          testId="project-create"
          leading={<Icons.Plus className="h-4 w-4 text-muted" />}
          title={t("newProject")}
          onSelect={() => nav.push({ page: "projects-new" })}
        />
      </PocketSection>
    </div>
  );
}
